/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlControlComponent } from './ControlControlComponent';
import {
    ControlControlComponentFromJSON,
    ControlControlComponentFromJSONTyped,
    ControlControlComponentToJSON,
} from './ControlControlComponent';

/**
 * 
 * @export
 * @interface ControlGetClientComponentsResponse
 */
export interface ControlGetClientComponentsResponse {
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlGetClientComponentsResponse
     */
    pre_purchase_components?: { [key: string]: Array<ControlControlComponent>; };
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlGetClientComponentsResponse
     */
    active_components?: { [key: string]: Array<ControlControlComponent>; };
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlGetClientComponentsResponse
     */
    expired_components?: { [key: string]: Array<ControlControlComponent>; };
    /**
     * 
     * @type {{ [key: string]: Array<ControlControlComponent>; }}
     * @memberof ControlGetClientComponentsResponse
     */
    expiring_subscriptions?: { [key: string]: Array<ControlControlComponent>; };
}

/**
 * Check if a given object implements the ControlGetClientComponentsResponse interface.
 */
export function instanceOfControlGetClientComponentsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlGetClientComponentsResponseFromJSON(json: any): ControlGetClientComponentsResponse {
    return ControlGetClientComponentsResponseFromJSONTyped(json, false);
}

export function ControlGetClientComponentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetClientComponentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pre_purchase_components': !exists(json, 'pre_purchase_components') ? undefined : json['pre_purchase_components'],
        'active_components': !exists(json, 'active_components') ? undefined : json['active_components'],
        'expired_components': !exists(json, 'expired_components') ? undefined : json['expired_components'],
        'expiring_subscriptions': !exists(json, 'expiring_subscriptions') ? undefined : json['expiring_subscriptions'],
    };
}

export function ControlGetClientComponentsResponseToJSON(value?: ControlGetClientComponentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pre_purchase_components': value.pre_purchase_components,
        'active_components': value.active_components,
        'expired_components': value.expired_components,
        'expiring_subscriptions': value.expiring_subscriptions,
    };
}

